module.exports = __webpack_public_path__ + "static/media/exist-educate.83216cde.png";